import React, { memo } from 'react';
import CardCount from '../../../../../components/CardCount';

interface CustomHeaderProps {
  dataCards: { title: string; value: number }[];
}

const CustomHeader: React.FC<CustomHeaderProps> = ({ dataCards }) => (
  <div className="display-flex flex-row align-items-stretch width-100pct rounded-large gap-16 padding-left-10">
    {dataCards.map((card) => (
      <div
        key={card.title}
        className="width-100pct flex-1 min-width-200 max-width-300 margin-right-20"
      >
        <CardCount
          borderColor="#22bcd4"
          label={card.title}
          value={card.value}
        />
      </div>
    ))}
  </div>
);

export default memo(CustomHeader); 